import {RemotePostGraceBotEvent} from 'data/usecases/private/my-payments-flow/remote-grace-bot-event';
import {PostGraceBotEvent} from 'domain/usecases/private/my-payments-flow/post-grace-bot-event';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostGraceBotEvent = (): PostGraceBotEvent =>
	new RemotePostGraceBotEvent(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.graceBotEvent),
		makeAuthorizeHttpClientDecorator(),
	);
